import React, { useContext } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { JobSearchContext } from '../../context';
import './sorting_filter.scss';

const SORTING_OPTIONS = [
  {text: 'Relevance', field: '_score', order: 'desc'},
  {text: 'Publication date', field: 'updated_at', order: 'desc'},
  {text: 'Closing date', field: 'closing_date', order: 'asc'},
];

const SortingFilter = () => {
  const { field, setField, setOrder} = useContext(JobSearchContext);

  const onSortingChange = (newField: string, newOrder: string) => {
    setField(newField);
    setOrder(newOrder);
  };

  const title = (
    <span>
      Sort by: {SORTING_OPTIONS.find((option) => option.field === field).text}{' '}
    </span>
  );

  return (
    <div className='ps-0 devex-react-bootstrap-dropdown-overwrite'>
      <DropdownButton
        id='job-search-sorting-filter'
        variant='secondary'
        size='sm'
        title={title}
      >
        {
          SORTING_OPTIONS.map((option) => (
            <Dropdown.Item
              key={option.field}
              onClick={() => onSortingChange(option.field, option.order)}
            >
              {option.text}
            </Dropdown.Item>
          ))
        }
      </DropdownButton>
    </div>
  );
};

export default SortingFilter;
